import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import fr from 'facet-rest';
import Uploader from 'Components/Files/Uploader';
import { useSnackbarContext } from 'Context/SnackbarContext';

const UploadTransitionRecommendedPlannerCSVButton = ({
  plannerTransitionHouseholdPageResource,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const [isProcessing, setIsProcessing] = useState(false);

  const UploadTransitionRecommendedPlannerButtonComponent = plannerTransitionHouseholdPageResource.withRelationship(
    fr.relationships.uploadTransitionRecommendedPlannerCSV.name,
    (uploadTransitionRecommendedPlannerRel) => (
      <Uploader
        url={uploadTransitionRecommendedPlannerRel.link('related').url()}
        onStart={() => {
          setIsProcessing(true);
        }}
        onFinally={() => {
          setIsProcessing(false);
        }}
        onCatch={(e) => displayErrorMessage(e, 'Failed to upload file')}
        successToastMessage={'CSV upload complete'}
        params={null}
      >
        <FDSecondaryActionButton
          label={uploadTransitionRecommendedPlannerRel.meta('prompt')}
          size={'sm'}
          loading={isProcessing}
        />
      </Uploader>
    ),
    () => null,
  );

  return UploadTransitionRecommendedPlannerButtonComponent;
};

UploadTransitionRecommendedPlannerCSVButton.defaultProps = {
};

UploadTransitionRecommendedPlannerCSVButton.propTypes = {
  plannerTransitionHouseholdPageResource: PropTypes.object.isRequired,
};

export default UploadTransitionRecommendedPlannerCSVButton;
